import React from 'react';
import image1 from "../../assets/gallery/c1.jpeg";
import image2 from "../../assets/gallery/real2.jpeg";
import './servicespage.css';

function Servicepage() {
  return (
    <>
      <div className="row text-center mb-4 mt-5">
        <div className="section-title clearfix d-flex flex-column align-items-center">
          <div class="title-header">
            <h5 style={{ textTransform: "uppercase", color: " #FFA800" }}>our services</h5>
            {/* <h3>New Sky Property & Projects Private Limited (NSPP)</h3> */}
          </div>
          <div className='underline' style={{ width: "7%" }} ></div>
        </div>
      </div>
      <div className="servicepage-container">
        <div className="servicepage-row">

          {/* Construction Card */}
          <div className="servicepage-card">
            <div className="servicepage-card-inner">
              <div className="servicepage-card-front">
                <img src={image1} alt="Construction" className="servicepage-image" />
                {/* <div className="servicepage-overlay">Construction</div> */}
              </div>
              <div className="servicepage-card-back1">
                <div className="servicepage-overlay">


                  <h4><b>Construction Services</b></h4>
                  <p >At New Sky Property and Projects Pvt. Ltd., we provide complete construction solutions for residential, commercial, and industrial projects. From design to handover, our expert team ensures quality, safety, 
                    and timely delivery—building spaces that turn your vision into reality.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Real Estate Card */}
          <div className="servicepage-card">
            <div className="servicepage-card-inner">
              <div className="servicepage-card-front">
                <img src={image2} alt="Real Estate" className="servicepage-image" />
                {/* <div className="servicepage-overlay">Real Estate</div> */}
              </div>
              <div className="servicepage-card-back">
                <div className="servicepage-overlay">
                  <h4><b> Real Estate Services</b></h4>
                  <p>At New Sky Property and Projects Pvt. Ltd., Our real estate division offers trusted solutions for buying, selling, and developing properties. From sourcing to legal checks and registration, we ensure every deal is smooth,
                     transparent, and value-driven—backed by a team you can trust.</p>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default Servicepage;
